import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';
import { ERROR_AFTER_DEADLINE, ERROR_INVALID_ORDER_CONTROL_PATTERN } from "../../../../utils/constants"

const fetchDefault = (payload) => (dispatch) => {
    return ApiService.get(Path.ORDER_ITEMS_GET_LIST, payload)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
        }).catch(()=>{
            dispatch(Actions.setList([])); 
        })
};

const updateOrders = (list, loginId, deliveryDttm, invalidMessage) => () => { 
    let strType = ERROR_AFTER_DEADLINE === invalidMessage || ERROR_INVALID_ORDER_CONTROL_PATTERN === invalidMessage ? invalidMessage : "web"
    return ApiService.post(Path.ORDER_ITEMS_GET_LIST + "/" + loginId + "/" + deliveryDttm + "/"+strType, list)
        .then((response) => {
            return (response.data);
        })
};

const fetchDeadline = (proposalId, deliveryDttm) => () => {
    return ApiService.post(Path.ORDER_ITEMS_GET_LIST + "/" + proposalId + "/" + deliveryDttm)
        .then((response) => {
            return response.data.data;
        })
};

export {
    fetchDefault,
    updateOrders,
    fetchDeadline
};
